import React from 'react';
import s from '../Card.scss';

export const CategoryLoadingCard = () => {
    return (
        <div className={s.loadingContainer}>
            <div className={[s.specialBox, s.category].join(' ')}>
                <div className={s.line}>
                    <div className={s.feedTitle} />
                </div>
                <div className={s.content}>
                    <div className={s.img} />
                    <div className={s.brief}>
                        <div className={s.line}><div className={s.feedTitle} /></div>
                        <div className={s.line}><div className={s.feedTitle} /></div>
                    </div>
                </div>
            </div>
            <div className={s.line}><div className={s.feedTitle} /></div>
            <div className={s.line}><div className={s.feedTitle} /></div>
            <div className={s.line}><div className={s.feedTitle} /></div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/CategoryCard/Loading.tsx